var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-home"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "100px",
      "padding-bottom": "200px"
    }
  }, [_vm._v("\n\t\t正在加载...\n\t")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-44b506bc","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 240
// module chunks = 0